import { IconDashboard } from "@suse-o11y/icons";
import React from "react";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { DASHBOARDS_OVERVIEW_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const DashboardsOverviewBreadcrumb: React.FC = () => {
	const dashboardsOverviewLink = useNavigateToLink(DASHBOARDS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<BreadcrumbLayout
			icon={<IconDashboard className={BREADCRUMB_ICON_CLASS} />}
			label="Dashboards"
			to={dashboardsOverviewLink}
		/>
	);
};
